import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["radiobutton", "irrelevantCheckbox"];

  connect() {
    const radioChecked = this.radiobuttonTargets.find(
      (radiobutton) => radiobutton.checked
    );
    if (!radioChecked) return;
    this.scrollButtonIntoView(radioChecked);
  }

  toggle = (event) => {
    if (event.target.checked) {
      if (this.hasRadiobuttonTarget) {
        this.radiobuttonTargets.forEach((radiobutton) => {
          radiobutton.checked = false;
        });
      }
    } else {
      const defaultButton = this.radiobuttonTargets.find(
        (radiobutton) => parseInt(radiobutton.value) === 1
      );
      this.scrollButtonIntoView(defaultButton);
      defaultButton.checked = true;
    }
  };

  toggleOff(event) {
    if (event.target.checked) {
      if (this.irrelevantCheckboxTarget) {
        this.irrelevantCheckboxTarget.checked = false;
      }

      this.scrollButtonIntoView(event.target);
    }
  }

  // for events, call function with event.target, otherwise call with objectName
  scrollButtonIntoView(scrollable) {
    scrollable.parentNode.scrollIntoView({
      inline: "center",
      block: "nearest",
      behavior: "smooth",
    });
  }

  togglePrev() {
    const radioChecked = this.radiobuttonTargets.find(
      (radiobutton) => radiobutton.checked
    );

    if (this.irrelevantCheckboxTarget.checked || !radioChecked) {
      const previousInput = this.radiobuttonTargets.find(
        (radiobutton) => radiobutton.value == 1
      );
      previousInput.checked = true;
      this.irrelevantCheckboxTarget.checked = false;
      this.scrollButtonIntoView(previousInput);
    } else {
      const activeGrade = parseInt(radioChecked.value);

      const previousInput = this.radiobuttonTargets.find((radiobutton) => {
        const buttonValue = parseInt(radiobutton.value);
        return activeGrade === 1
          ? buttonValue === 13
          : buttonValue === activeGrade - 1;
      });

      previousInput.checked = true;
      this.scrollButtonIntoView(previousInput);
    }
  }

  toggleNext() {
    const radioChecked = this.radiobuttonTargets.find(
      (radiobutton) => radiobutton.checked
    );

    if (this.irrelevantCheckboxTarget.checked || !radioChecked) {
      const nextInput = this.radiobuttonTargets.find(
        (radiobutton) => radiobutton.value == 1
      );
      nextInput.checked = true;
      this.irrelevantCheckboxTarget.checked = false;
      this.scrollButtonIntoView(nextInput);
    } else {
      const activeGrade = parseInt(radioChecked.value);

      const nextInput = this.radiobuttonTargets.find((radiobutton) => {
        const buttonValue = parseInt(radiobutton.value);

        return activeGrade === 13
          ? buttonValue === 1
          : buttonValue === activeGrade + 1;
      });

      nextInput.checked = true;
      this.scrollButtonIntoView(nextInput);
    }
  }
}
